<template>
  <div>
    <div class="titlebar h-16 bg-gray-300 flex justify-between fixed top-0 left-0 w-full">
      <div class="flex justify-center items-center ml-5">
        <img class="cursor-pointer" @click="$router.push('/app/home')" src="../ics/home.svg" alt="">
      </div>
      <div class="flex justify-center items-center">
        Notification
      </div>
      <div class="flex justify-center items-center mr-5">
        <img class="cursor-pointer" @click="$router.push('/app/home')" src="../ics/close.svg" alt="">
      </div>
    </div>
    <div class="h-16"></div>

    <div class="">
      Notification
    </div>

    <!-- <div class="h-16"></div>
    <div class="bottombar h-16 bg-gray-300 flex justify-between fixed bottom-0 left-0 w-full">
      <div class="flex justify-center items-center ml-5">
        <img src="../ics/plus.svg" alt="">
      </div>
      <div class="flex justify-center items-center">
        <img src="../ics/bell.svg" alt="">
      </div>
      <div class="flex justify-center items-center mr-5">
        <img src="../ics/reload.svg" alt="">
      </div>
    </div> -->
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
